/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import {
  CREATE_NEW_MESSAGE_FROM_FAQ,
  DOCUMENT_CENTER_FROM_FAQ,
  PAPERLESS_NOTIFICATIONS_PATH,
  PAYMENT_OPTIONS_PATH,
  PROFILE_PATH,
} from 'src/constants/routePaths';
import {
  FAQComponentItem,
  FAQComponentItemParagraphWithLinks,
  FAQComponentProps,
  FAQComponentSection,
  resourceKey,
  LinkType,
  FAQComponentItemNumberedList,
  NumberedListType,
  FAQComponentItemParagraph,
  FAQComponentItemList,
  FAQComponentWithLinksProps,
  FAQComponentItemSubTitle,
  FAQComponentItemTextWithLinks,
  FAQComponentItemParagraphWithTitle,
} from './FAQComponent';
import { Brand } from '../../../types';
// @ts-ignore
import thirdPartyAuthorizationAudi from '../../../assets/pdfs/faq/ThirdPartyAuthorization-Audi.pdf';
// @ts-ignore
import thirdPartyAuthorizationVW from '../../../assets/pdfs/faq/ThirdPartyAuthorization-VW.pdf';
import i18n from '../../../localization/i18n';
import * as rk from '../../../localization/resourceKeys';

const LoanFAQ: React.FC<Omit<FAQComponentProps, 'accountType'>> = ({ brand }) => {
  const messageCenterUrl = CREATE_NEW_MESSAGE_FROM_FAQ;
  const dmvPolicyLink = 'https://www.dmvusa.com/';
  const styleBrand = brand === Brand.AUDI ? Brand.AUDI : Brand.VW;
  const showDDCFAQ = process.env.REACT_APP_DDC === 'true';
  const documentCenterUrl = DOCUMENT_CENTER_FROM_FAQ;
  const paperlessNotificationUrl = PAPERLESS_NOTIFICATIONS_PATH;
  const accountSettingsUrl = PROFILE_PATH;

  return (
    <>
      <div className='c-faq' role='main'>
        <h1 className='header'>{i18n.t(rk.FAQ_TITLE) as string}</h1>
        <FAQComponentSection value={i18n.t(rk.LOAN_FAQ_MOSTCOMMONQUESTIONS)}>
          {/* FAQ 1 */}

          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_TITLES_QUESTION1)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER1_VW)}
              links={[
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK) as string,
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 2 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_TITLES_QUESTION2)}>
            <FAQComponentItemParagraph value={resourceKey('LOAN_FAQ_ACCOUNTS_ANSWER32_PARAGRAPH1', styleBrand)} />

            <FAQComponentItemList
              items={[
                i18n.t(rk.LOAN_FAQ_TITLES_ANSWER2_LISTITEM1_VW),
                {
                  value: i18n.t(rk.LOAN_FAQ_TITLES_ANSWER2_LISTITEM2_VW),
                  links: [
                    {
                      key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK),
                      value: messageCenterUrl,
                      type: LinkType.NavLink,
                    },
                  ],
                } as FAQComponentWithLinksProps,
                i18n.t(rk.LOAN_FAQ_TITLES_ANSWER2_LISTITEM3_VW),
                i18n.t(rk.LOAN_FAQ_TITLES_ANSWER2_LISTITEM4_VW),
                {
                  value: i18n.t(rk.LOAN_FAQ_TITLES_ANSWER2_LISTITEM5_VW),
                  links: [
                    {
                      key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM5_LINK1),
                      value: documentCenterUrl as string,
                      type: LinkType.NavLink,
                    },
                  ],
                } as FAQComponentWithLinksProps,
                i18n.t(rk.LOAN_FAQ_TITLES_ANSWER2_LISTITEM6_VW) as string,
                {
                  value: i18n.t(rk.LOAN_FAQ_TITLES_ANSWER2_LISTITEM7_VW) as string,
                  links: [
                    {
                      key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM7_LINK1) as string,
                      value: paperlessNotificationUrl as string,
                      type: LinkType.NavLink,
                    },
                    {
                      key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ENROLL_IN_AUTOPAY) as string,
                      type: LinkType.Nav,
                    },
                  ],
                } as FAQComponentWithLinksProps,
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 3 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_TITLES_QUESTION3)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER3_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK) as string,
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER3_PARAGRAPH2_VW)} />
          </FAQComponentItem>
          {/* FAQ 4 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_TITLES_QUESTION4)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER4_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION4_ANSWER1_PARAGRAPH1_LINK1),
                  type: LinkType.Nav,
                },
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER4_PARAGRAPH2_VW)} />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER4_PARAGRAPH3_VW)} />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER4_PARAGRAPH4_VW)} />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER4_PARAGRAPH5_VW)} />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER4_PARAGRAPH6_VW)}
              links={[
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER4_PARAGRAPH7_VW)} />
          </FAQComponentItem>
          {/* FAQ 5 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_TITLES_QUESTION5)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER5_PARAGRAPH_VW)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ENROLL_IN_AUTOPAY),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 6 and 7 */}
          <FAQComponentItem
            value={showDDCFAQ ? i18n.t(rk.FAQ_LEASE_NEW_QUESTION6) : i18n.t(rk.FAQ_PAYMENTOPTIONS_QUESTION5)}
          >
            <FAQComponentItemParagraphWithLinks
              value={
                showDDCFAQ
                  ? i18n.t(rk.FAQ_PAYMENTOPTIONS_ANSWER5_PARAGRAPH1_US)
                  : i18n.t(resourceKey('FAQ_PAYMENTOPTIONS_ANSWER5_PARAGRAPH1_US_DDC_DISABLED', styleBrand))
              }
              links={
                showDDCFAQ
                  ? [
                      {
                        key: i18n.t(rk.FAQ_PAYMENTOPTIONS_ANSWER5_LINK_US),
                        type: LinkType.NavLink,
                        value: PAYMENT_OPTIONS_PATH,
                      },
                    ]
                  : []
              }
            />
            {showDDCFAQ && (
              <>
                <p>{i18n.t(rk.FAQ_PAYMENTOPTIONS_ANSWER5_PARAGRAPH2_US) as string}</p>
                <p>{i18n.t(rk.FAQ_PAYMENTOPTIONS_ANSWER5_PARAGRAPH3_US) as string}</p>
                <ul>
                  <li>{i18n.t(rk.FAQ_PAYMENTOPTIONS_ANSWER5_LIST1_ITEM1_US) as string}</li>
                  <li>{i18n.t(rk.FAQ_PAYMENTOPTIONS_ANSWER5_LIST1_ITEM2_US) as string}</li>
                </ul>
                <p>{resourceKey('FAQ_PAYMENTOPTIONS_ANSWER5_PARAGRAPH4_US', styleBrand) as string}</p>
                <ul>
                  <li>{i18n.t(rk.FAQ_PAYMENTOPTIONS_ANSWER5_LIST2_ITEM1_US) as string}</li>
                  <li>{i18n.t(rk.FAQ_PAYMENTOPTIONS_ANSWER5_LIST2_ITEM2_US) as string}</li>
                  <li>{i18n.t(rk.FAQ_PAYMENTOPTIONS_ANSWER5_LIST2_ITEM4_US) as string}</li>
                </ul>
              </>
            )}
          </FAQComponentItem>
          {/* FAQ 8 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_QUESTION46)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER46_VW_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_MOVING_ANSWER1_LINK),
                  value: accountSettingsUrl,
                  type: LinkType.NavLink,
                },
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 9 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_TITLES_QUESTION9)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER9_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ACCOUNT_SETTINGS_LINK),
                  value: accountSettingsUrl,
                  type: LinkType.NavLink,
                },
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER9_PARAGRAPH2_VW)}
              links={[
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 10 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_TITLES_QUESTION10)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER10_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraphWithTitle value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER10_BOLDTEXT_VW)}>
              {resourceKey('LOAN_FAQ_TITLES_ANSWER10_PARAGRAPH2', styleBrand)}
            </FAQComponentItemParagraphWithTitle>

            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER10_PARAGRAPH3_VW)} />
            <FAQComponentItemParagraph value={resourceKey('LOAN_FAQ_TITLES_ANSWER10_PARAGRAPH4', styleBrand)} />
          </FAQComponentItem>
          {/* FAQ 11 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_TITLES_QUESTION11)}>
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER11_PARAGRAPH_VW)} />
          </FAQComponentItem>
        </FAQComponentSection>
        <FAQComponentSection value={i18n.t(rk.FAQ_TITLES)}>
          {/* FAQ 12 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_TITLES_QUESTION1)}>
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_TITLES_ANSWER1_PARAGRAPH1)} />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_TITLES_ANSWER1_PARAGRAPH2)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 13 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_TITLES_QUESTION8)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_TITLES_ANSWER8_PARAGRAPH1_WITHLINK_VW)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_ANSWER8_LINK1),
                  type: LinkType.Nav,
                },
              ]}
            />

            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_TITLES_REGULAR_MAIL_ADDRESS_PARAGRAPH1)} bold />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_TITLES_REGULAR_MAIL_ADDRESS_PARAGRAPH2)} />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_TITLES_OVERNIGHT_MAIL_ADDRESS_PARAGRAPH1)} bold />
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_TITLES_OVERNIGHT_MAIL_ADDRESS_PARAGRAPH2)} />
          </FAQComponentItem>
          {/* FAQ 14 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_TITLES_QUESTION9)}>
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_TITLES_ANSWER9)} />
          </FAQComponentItem>
          {/* FAQ 15 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_TITLES_QUESTION10)}>
            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_TITLES_ANSWER10_PARAGRAPH1)} />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_TITLES_ANSWER10_LISTITEM1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
            <FAQComponentItemParagraph value={resourceKey('FAQ_TITLES_ANSWER10_LISTITEM2', styleBrand)} />

            <FAQComponentItemParagraph value={i18n.t(rk.FAQ_TITLES_ANSWER10_LISTITEM3)} />
          </FAQComponentItem>
          {/* FAQ 16 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_TITLES_QUESTION11)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_TITLES_ANSWER11_PARAGRAPH1', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_TITLES_ANSWER11_PARAGRAPH2)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_ANSWER11_PARAGRAPH2_LINK),
                  value: dmvPolicyLink,
                  type: LinkType.NewPage,
                },
              ]}
            />
          </FAQComponentItem>
        </FAQComponentSection>
        <FAQComponentSection value={i18n.t(rk.LOAN_FAQ_PAYMENTS)}>
          {/* FAQ 17 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_PAYMENTS_QUESTION17)}>
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER17_PARAGRAPH1_VW)} />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER17_PARAGRAPH2_VW)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM5_LINK1),
                  value: documentCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 18 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_PAYMENTS_QUESTION18)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER18_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ENROLL_IN_AUTOPAY),
                  type: LinkType.Nav,
                },
              ]}
            />{' '}
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER18_PARAGRAPH2_VW)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ENROLL_IN_AUTOPAY),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 19 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_PAYMENTS_QUESTION19)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER19_PARAGRAPH_VW)}
              links={[
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 20 ans 21 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_PAYMENTS_QUESTION20)}>
            {showDDCFAQ && (
              <>
                <FAQComponentItemParagraphWithLinks
                  value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER20_PARAGRAPH1_VW)}
                  links={[
                    {
                      key: i18n.t(rk.FAQ_TITLES_ANSWER11_PARAGRAPH2_LINK),
                      value: dmvPolicyLink,
                      type: LinkType.NewPage,
                    },
                  ]}
                />{' '}
                <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER20_PARAGRAPH2_VW)} />
                <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER20_PARAGRAPH3_VW)} />
                <FAQComponentItemNumberedList
                  type={NumberedListType.Number}
                  items={[
                    {
                      value: '',
                      children: <>{i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER20_LISTITEM1_VW)}</>,
                    },
                    {
                      value: '',
                      children: <>{i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER20_LISTITEM2_VW)}</>,
                    },
                  ]}
                />
                <FAQComponentItemParagraph value={resourceKey('LOAN_FAQ_PAYMENTS_ANSWER20_PARAGRAPH4', styleBrand)} />
                <FAQComponentItemNumberedList
                  type={NumberedListType.Number}
                  items={[
                    {
                      value: '',
                      children: <>{i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER20_LISTITEM3_VW)}</>,
                    },
                    {
                      value: '',
                      children: <>{i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER20_LISTITEM4_VW)}</>,
                    },
                    {
                      value: '',
                      children: <>{i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER20_LISTITEM5_VW)}</>,
                    },
                  ]}
                />
              </>
            )}
            {!showDDCFAQ && (
              <FAQComponentItemParagraph
                value={resourceKey('FAQ_PAYMENTOPTIONS_ANSWER5_PARAGRAPH1_US_DDC_DISABLED', styleBrand)}
              />
            )}
          </FAQComponentItem>
          {/* FAQ 22 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_PAYMENTS_QUESTION22)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER22_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraph value={resourceKey('LOAN_FAQ_PAYMENTS_ANSWER22_PARAGRAPH2', styleBrand)} />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER22_PARAGRAPH3_VW)} />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER22_PARAGRAPH4_VW)} />
          </FAQComponentItem>
          {/* FAQ 23 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_PAYMENTS_QUESTION23)}>
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER23_PARAGRAPH1_VW)} />
            <FAQComponentItemList
              items={[
                {
                  value: i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER23_LISTITEM1_VW) as string,
                  links: [
                    {
                      key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ENROLL_IN_AUTOPAY),
                      type: LinkType.Nav,
                    },
                  ],
                } as FAQComponentWithLinksProps,
                {
                  value: i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER23_LISTITEM2_VW) as string,
                  links: [
                    {
                      key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                      type: LinkType.Nav,
                    },
                  ],
                } as FAQComponentWithLinksProps,
                resourceKey('LOAN_FAQ_PAYMENTS_ANSWER23_LISTITEM3', styleBrand),
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER23_PARAGRAPH2_VW)} />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER23_PARAGRAPH3_VW)} />
          </FAQComponentItem>
          {/* FAQ 24 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_PAYMENTS_QUESTION24)}>
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER24_PARAGRAPH1_VW)} />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER24_PARAGRAPH2_VW)} />
          </FAQComponentItem>
          {/* FAQ 25 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_PAYMENTS_QUESTION25)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER25_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 26 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_PAYMENTS_QUESTION26)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER26_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER26_PARAGRAPH2_VW)} />
          </FAQComponentItem>
          {/* FAQ 27 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_PAYMENTS_QUESTION27)}>
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER27_PARAGRAPH1_VW)} />
          </FAQComponentItem>
          {/* FAQ 28 */}
          <FAQComponentItem value={resourceKey('LOAN_FAQ_PAYMENTS_QUESTION28', styleBrand)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER28_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 29 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_PAYMENTS_QUESTION29)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER29_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
        </FAQComponentSection>
        <FAQComponentSection value={i18n.t(rk.LOAN_FAQ_ACCOUNTMANAGEMENT)}>
          {/* FAQ 30 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_QUESTION30)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER30_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM5_LINK1),
                  value: documentCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 31 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_QUESTION31)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER31_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ACCOUNT_SETTINGS_LINK),
                  value: accountSettingsUrl,
                  type: LinkType.NavLink,
                },
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER31_PARAGRAPH2_VW)}
              links={[
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 32 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_QUESTION32)}>
            <FAQComponentItemParagraph value={resourceKey('LOAN_FAQ_ACCOUNTS_ANSWER32_PARAGRAPH1', styleBrand)} />
            <FAQComponentItemList
              items={[
                i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER32_LISTITEM1_VW),
                i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER32_LISTITEM2_VW),
                i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER32_LISTITEM3_VW),
                i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER32_LISTITEM4_VW),
                {
                  value: i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER32_LISTITEM5_VW) as string,
                  links: [
                    {
                      key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION2_ANSWER1_LISTITEM5_LINK1) as string,
                      value: documentCenterUrl,
                      type: LinkType.NavLink,
                    },
                  ],
                } as FAQComponentWithLinksProps,
                i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER32_LISTITEM6_VW),
                i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER32_LISTITEM7_VW),
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 33 */}
          <FAQComponentItem value={resourceKey('LOAN_FAQ_ACCOUNTS_QUESTION33', styleBrand)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER33_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 34 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_QUESTION34)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER34_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ACCOUNT_SETTINGS_LINK),
                  value: accountSettingsUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 35 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_TITLES_QUESTION4)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER35_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION4_ANSWER1_PARAGRAPH1_LINK1),
                  type: LinkType.Nav,
                },
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER35_PARAGRAPH2_VW)} />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER35_PARAGRAPH3_VW)} />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER35_PARAGRAPH4_VW)}
              links={[
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER35_PARAGRAPH5_VW)} />
          </FAQComponentItem>
          {/* FAQ 36 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION5)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_QUESTION5_ANSWER1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ENROLL_IN_AUTOPAY),
                  type: LinkType.Nav,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 37 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_PAPERLESSBILLING_QUESTION4)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_PAPERLESSBILLING_ANSWER4_PARAGRAPH1', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK1),
                  value: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK1),
                  type: LinkType.Email,
                },
                {
                  key: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK2),
                  value: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK2),
                  type: LinkType.Email,
                },
                {
                  key: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK3),
                  value: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK3),
                  type: LinkType.Email,
                },
                {
                  key: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK5),
                  value: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK5),
                  type: LinkType.Email,
                },
                {
                  key: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK6),
                  value: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK6),
                  type: LinkType.Email,
                },
                {
                  key: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK7),
                  value: i18n.t(rk.FAQ_PAPERLESSBILLING_ANSWER4_LINK7),
                  type: LinkType.Email,
                },
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.FAQ_LEASE_NEW_ACCOUNT_MANAGEMENT_QUESTION4_ANSWER1_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_ACCOUNT_SETTINGS_LINK),
                  value: accountSettingsUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 38 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_QUESTION38)}>
            <FAQComponentItemParagraph value={resourceKey('LOAN_FAQ_ACCOUNTS_ANSWER38_PARAGRAPH1', styleBrand)} />
          </FAQComponentItem>
          {/* FAQ 39 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_QUESTION39)}>
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER39_VW_PARAGRAPH1)} />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER39_VW_PARAGRAPH2)} />
          </FAQComponentItem>
          {/* FAQ 40 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_QUESTION40)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_ACCOUNTS_ANSWER40_VW_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_THIRDPARTYAUTHORIZATION_ANSWER1_LINK1),
                  value: brand === Brand.AUDI ? thirdPartyAuthorizationAudi : thirdPartyAuthorizationVW,
                  type: LinkType.NewPage,
                },
                {
                  key: i18n.t(rk.FAQ_THIRDPARTYAUTHORIZATION_ANSWER1_LINK2),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
          {/* FAQ 41 */}
          <FAQComponentItem value={resourceKey('LOAN_FAQ_ACCOUNTS_QUESTION41', styleBrand)}>
            <FAQComponentItemParagraph value={resourceKey('LOAN_FAQ_ACCOUNTS_ANSWER41_PARAGRAPH1', styleBrand)} />
          </FAQComponentItem>
        </FAQComponentSection>
        <FAQComponentSection value={i18n.t(rk.LOAN_FAQ_PAYOFF)}>
          {/* FAQ 42 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_PAYOFFS_QUESTION42)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_PAYOFFS_ANSWER42_VW_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.LOAN_FAQ_HOMEPAGE_LINK),
                  type: LinkType.Nav,
                },
              ]}
            />
            <FAQComponentItemParagraphWithTitle value={i18n.t(rk.LOAN_FAQ_TITLES_ANSWER10_BOLDTEXT_VW)}>
              {resourceKey('LOAN_FAQ_TITLES_ANSWER10_PARAGRAPH2', styleBrand)}
            </FAQComponentItemParagraphWithTitle>
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_PAYOFFS_ANSWER42_VW_PARAGRAPH3)} />
            <FAQComponentItemParagraph value={resourceKey('FAQ_LEASE_NEW_QUESTION8_ANSWER1_PARAGRAPH3', styleBrand)} />
          </FAQComponentItem>

          {/* FAQ 43 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_PAYOFFS_QUESTION43)}>
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_PAYOFFS_ANSWER43_VW_PARAGRAPH1)} />
          </FAQComponentItem>

          {/* FAQ 44 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_PAYOFFS_QUESTION44)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_PAYOFFS_ANSWER44_VW_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
        </FAQComponentSection>
        <FAQComponentSection value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS)}>
          {/* FAQ 45 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_QUESTION45)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER45_VW_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
            <FAQComponentItemParagraph
              value={resourceKey('LOAN_FAQ_SPECIALSITUATIONS_ANSWER45_PARAGRAPH2', styleBrand)}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER45_VW_PARAGRAPH3)} />
          </FAQComponentItem>

          {/* FAQ 46 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_QUESTION46)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER46_VW_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_MOVING_ANSWER1_LINK),
                  value: accountSettingsUrl,
                  type: LinkType.NavLink,
                },
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>

          {/* FAQ 47 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_SCRA_QUESTION1)}>
            <FAQComponentItemParagraph value={resourceKey('FAQ_SCRA_ANSWER1_PARAGRAPH1', styleBrand)} />
            <FAQComponentItemList
              items={[
                resourceKey('FAQ_SCRA_ANSWER1_LISTITEM1', styleBrand),
                resourceKey('FAQ_SCRA_ANSWER1_LISTITEM2', styleBrand),
                resourceKey('FAQ_SCRA_ANSWER1_LISTITEM3', styleBrand),
                resourceKey('FAQ_SCRA_ANSWER1_LISTITEM4', styleBrand),
                resourceKey('FAQ_SCRA_ANSWER1_LISTITEM5', styleBrand),
                resourceKey('FAQ_SCRA_ANSWER1_LISTITEM6', styleBrand),
                resourceKey('FAQ_SCRA_ANSWER1_LISTITEM7', styleBrand),
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_SCRA_ANSWER1_PARAGRAPH2', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_SCRA_ANSWER1_LINK1),
                  value: 'https://legalassistance.law.af.mil/',
                  type: LinkType.NewPage,
                },
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_SCRA_ANSWER1_PARAGRAPH3', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK) as string,
                  value: messageCenterUrl as string,
                  type: LinkType.NavLink,
                },
              ]}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_ANSWER1_PARAGRAPH1)}
            />
            <ul>
              <li>{i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH1_LISTITEM1) as string}</li>
              <li>
                <FAQComponentItemTextWithLinks
                  value={i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH1_LISTITEM2)}
                  links={[
                    {
                      key: 'https://scra.dmdc.osd.mil',
                      value: 'https://scra.dmdc.osd.mil',
                      type: LinkType.NewPage,
                    },
                  ]}
                />
              </li>
              <li>
                {i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH1_LISTITEM3) as string}
                <ul>
                  <li>{i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM3_EXTRA_1) as string}</li>
                  <li>{i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM3_EXTRA_2) as string}</li>
                </ul>
              </li>
            </ul>
            <FAQComponentItemParagraph
              value={i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_ANSWER1_PARAGRAPH2)}
            />
            <FAQComponentItemList
              items={[
                i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM1),
                i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM2),
                i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM3),
                i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM4),
                i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM5),
                i18n.t(rk.FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION1_PARAGRAPH2_LISTITEM6),
              ]}
            />
          </FAQComponentItem>

          {/* FAQ 48 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_QUESTION48)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('LOAN_FAQ_SPECIALSITUATIONS_ANSWER48_PARAGRAPH1', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER48_VW_PARAGRAPH2)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER48_VW_PARAGRAPH3)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>

          {/* FAQ 49 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_CONSUMERCREDIT_QUESTION1)}>
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER49_VW_PARAGRAPH1)} />
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('LOAN_FAQ_SPECIALSITUATIONS_ANSWER49_PARAGRAPH2', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER49_VW_PARAGRAPH3)} />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER49_VW_PARAGRAPH4)} />
          </FAQComponentItem>

          {/* FAQ 50 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_QUESTION50)}>
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_PARAGRAPH1)} />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_LISTITEM1)} />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_LISTITEM2)} />
            <ul>
              <li>{i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_LISTITEM3) as string}</li>
            </ul>
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_LISTITEM4)} />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_PARAGRAPH2)} />
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_PARAGRAPH3', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK) as string,
                  value: messageCenterUrl as string,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>

          {/* FAQ 51 */}
          <FAQComponentItem value={resourceKey('FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION4', styleBrand)}>
            <FAQComponentItemParagraph
              value={resourceKey('FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION4_ANSWER1_PARAGRAPH1', styleBrand)}
            />
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_LEASE_NEW_SPECIALSITUATIONS_QUESTION4_ANSWER1_PARAGRAPH2', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK) as string,
                  value: messageCenterUrl as string,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>
        </FAQComponentSection>
        <FAQComponentSection value={i18n.t(rk.LOAN_FAQ_RELIEF)}>
          {/* FAQ 52 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_DISASTER_RELIEF_QUESTION1)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey('FAQ_LEASE_NEW_DISASTER_RELIEF_QUESTION1_ANSWER1_PARAGRAPH1', styleBrand)}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_QUESTION_MESSAGECENTER_LINK) as string,
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>

          {/* FAQ 53 */}
          <FAQComponentItem value={resourceKey('LOAN_FAQ_PAYMENTS_QUESTION28', styleBrand)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_PAYMENTS_ANSWER28_PARAGRAPH1_VW)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
          </FAQComponentItem>

          {/* FAQ 54 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_DISASTERRELIEF_QUESTION54)}>
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_DISASTERRELIEF_ANSWER54_VW_PARAGRAPH1)} />
          </FAQComponentItem>

          {/* FAQ 55 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_DISASTERRELIEF_QUESTION55)}>
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_DISASTERRELIEF_ANSWER55_VW_PARAGRAPH1)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
            <FAQComponentItemParagraphWithLinks
              value={i18n.t(rk.LOAN_FAQ_DISASTERRELIEF_ANSWER55_VW_PARAGRAPH2)}
              links={[
                {
                  key: i18n.t(rk.FAQ_TITLES_MESSAGES_LINK),
                  value: messageCenterUrl,
                  type: LinkType.NavLink,
                },
              ]}
            />
            <FAQComponentItemParagraph value={i18n.t(rk.LOAN_FAQ_DISASTERRELIEF_ANSWER55_VW_PARAGRAPH3)} />
          </FAQComponentItem>
        </FAQComponentSection>
        <FAQComponentSection value={i18n.t(rk.LOAN_FAQ_INSURANCEANDVEHICLEPROTECTIONS)}>
          {/* FAQ 56 */}
          <FAQComponentItem value={i18n.t(rk.LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_QUESTION56)}>
            <FAQComponentItemParagraph
              value={resourceKey('LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_ANSWER56_PARAGRAPH1', styleBrand)}
            />
            <FAQComponentItemParagraph
              value={i18n.t(rk.LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_ANSWER56_VW_PARAGRAPH2)}
            />
          </FAQComponentItem>

          {/* FAQ 57 */}
          <FAQComponentItem value={resourceKey('LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_QUESTION57', styleBrand)}>
            <FAQComponentItemParagraph
              value={resourceKey(
                'FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION2_ANSWER1_PARAGRAPH1',
                styleBrand
              )}
            />
            <FAQComponentItemParagraph
              small
              value={resourceKey(
                'FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION2_ANSWER1_PARAGRAPH2',
                styleBrand
              )}
            />
            <FAQComponentItemParagraph
              small
              value={resourceKey(
                'FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION2_ANSWER1_PARAGRAPH3',
                styleBrand
              )}
            />
            <FAQComponentItemParagraph
              small
              value={resourceKey(
                'FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION2_ANSWER1_PARAGRAPH4',
                styleBrand
              )}
            />
            <FAQComponentItemParagraph
              small
              value={resourceKey(
                'FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION2_ANSWER1_PARAGRAPH5',
                styleBrand
              )}
            />
          </FAQComponentItem>
          {/* FAQ 58 */}
          <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION3)}>
            <FAQComponentItemParagraphWithLinks
              value={resourceKey(
                'FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION3_ANSWER1_PARAGRAPH1',
                styleBrand
              )}
              links={[
                {
                  key: i18n.t(rk.FAQ_LEASE_NEW_INSURANCEANDVEHICLEPROTECTION_QUESTION3_ANSWER1_PARAGRAPH1_LINK1),
                  value: i18n.t(
                    brand === Brand.AUDI
                      ? 'https://www.audiusa.com/us/web/en/shopping-tools/dealer-search.html'
                      : 'https://www.vw.com/en/dealer-search.html?---=%7B%22dealer-search_featureappsection%22%3A%22%2F%22%7D'
                  ),
                  type: LinkType.NewPage,
                },
              ]}
            />
          </FAQComponentItem>
        </FAQComponentSection>
        {process.env.REACT_APP_SHOW_WF_QUESTIONS === 'true' && (
          <FAQComponentSection value={i18n.t(rk.LOAN_FAQ_WELLSFARGO)} dataTestId='wf-faq'>
            {/* FAQ 59 */}
            <FAQComponentItem value={resourceKey('FAQ_LEASE_NEW_WELLSFARGO_QUESTION1', styleBrand)}>
              <FAQComponentItemParagraph
                value={resourceKey('FAQ_LEASE_NEW_WELLSFARGO_QUESTION1_ANSWER1_PARAGRAPH1', styleBrand)}
              />
            </FAQComponentItem>
            {/* FAQ 60 */}
            <FAQComponentItem value={resourceKey('FAQ_LEASE_NEW_WELLSFARGO_QUESTION2', styleBrand)}>
              <FAQComponentItemSubTitle value={i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION2_ANSWER1_PARAGRAPH1)} />
              <FAQComponentItemList
                items={[
                  resourceKey('FAQ_LEASE_NEW_WELLSFARGO_QUESTION2_ANSWER1_PARAGRAPH1_LISTITEM1', styleBrand),
                  {
                    value: resourceKey('FAQ_LEASE_NEW_WELLSFARGO_QUESTION2_ANSWER1_PARAGRAPH1_LISTITEM2', styleBrand),
                    links: [
                      {
                        key: i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION3_ANSWER1_PARAGRAPH2_LINK1),
                        value:
                          'https://connect.secure.wellsfargo.com/auth/login/present?origin=cob&LOB=CONS&_gl=1*sfe2rf*_ga*MTQ1NjY2MjQyOC4xNzI5NjI0Njk3*_ga_7JXJJ2JF12*MTczMjIwOTY5OC45LjAuMTczMjIwOTY5OC42MC4wLjA.',
                        type: LinkType.NewPage,
                      },
                      {
                        key: i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION3_ANSWER1_PARAGRAPH2_LINK2),
                        value: 'https://www.wellsfargo.com/mobile-online-banking/apps/',
                        type: LinkType.NewPage,
                      },
                    ],
                  },
                ]}
              />
              <FAQComponentItemSubTitle value={i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION2_ANSWER1_PARAGRAPH2)} />
              <FAQComponentItemList
                items={[
                  i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION2_ANSWER1_PARAGRAPH2_LISTITEM1),
                  resourceKey('FAQ_LEASE_NEW_WELLSFARGO_QUESTION2_ANSWER1_PARAGRAPH2_LISTITEM2', styleBrand),
                ]}
              />
            </FAQComponentItem>
            {/* FAQ 61 */}
            <FAQComponentItem value={i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION3)}>
              <FAQComponentItemParagraph
                value={resourceKey('FAQ_LEASE_NEW_WELLSFARGO_QUESTION3_ANSWER1_PARAGRAPH1', styleBrand)}
              />
              <FAQComponentItemParagraphWithLinks
                value={i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION3_ANSWER1_PARAGRAPH2)}
                links={[
                  {
                    key: i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION3_ANSWER1_PARAGRAPH2_LINK1),
                    value:
                      'https://connect.secure.wellsfargo.com/auth/login/present?origin=cob&LOB=CONS&_gl=1*sfe2rf*_ga*MTQ1NjY2MjQyOC4xNzI5NjI0Njk3*_ga_7JXJJ2JF12*MTczMjIwOTY5OC45LjAuMTczMjIwOTY5OC42MC4wLjA.',
                    type: LinkType.NewPage,
                  },
                  {
                    key: i18n.t(rk.FAQ_LEASE_NEW_WELLSFARGO_QUESTION3_ANSWER1_PARAGRAPH2_LINK2),
                    value: 'https://www.wellsfargo.com/mobile-online-banking/apps/',
                    type: LinkType.NewPage,
                  },
                ]}
              />
            </FAQComponentItem>
          </FAQComponentSection>
        )}
      </div>
    </>
  );
};

export default LoanFAQ;
